module.exports = __webpack_public_path__ + "static/media/emailIcon.68ffd93d.svg";